import { Ref, watchEffect } from 'vue'

export const usePageTitle = (title: Ref) =>
  watchEffect(() => {
    if (title.value) {
      document.title = title.value
    }
  })
